import { Alert, AlertTitle, CircularProgress, Container, LinearProgress, Stack, Typography } from "@mui/material";
import AlertService from "../../services/AlertService";
import ProductoService from "../../services/ProductoService";
import UsuarioService from "../../services/UsuarioService";
import { useContext, useEffect, useState } from "react";
import { OptionReactSelect, Usuario, setUsuarioSelect } from "../../interfaces/UsuarioSearch";
import { CasUserContext } from "../../services/casUserContext";
import { TablaProductoIngresadoDTO } from "../../interfaces/TablaProductoIngresadoDTO";
import Select from 'react-select';
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import TableProductosSinProy from "../../componentes/Productos/ProductosSinProyecto";
import { PersonaInvDTO } from "../../interfaces/Usuarios/PersonaInvDTO";

const alertaService = new AlertService();
const productoService = new ProductoService();
const usuarioService = new UsuarioService();

export const BusqAdjuntarPage: React.FC<{}> = () =>{
    const[listUser,setListUser] = useState<Array<OptionReactSelect>>([]);
    const[listUsuario,setListUsuario] = useState<Array<PersonaInvDTO>>([]);
    let [productosIngresados,setProductosIngresados] = useState<Array<TablaProductoIngresadoDTO>>([]);
    const[ready,setReady] = useState(false);
    const[busqEnd,setBusqEnd] = useState(true);
    const[auth,setAuth] = useState(false);

    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const user = casUserContext.userData;

    const fetchData = async () =>{
        try{     
             await usuarioService.GetListUsuarios(token)
             .then((data) => {
                  //console.log(data);
                  if(data.status.isSuccessfully){
                    setListUsuario(data.listData);
                    setListUser(setUsuarioSelect(data.listData));
                    setReady(true);
                  }else{
                    alertaService.alertaAdvertencia("Error","No se cargaron los usuarios");
                    setReady(true);
                  }
              })               
             .catch((error) => console.error(error));                        
        }catch(error){
          console.error('Error:',error);
        }
      };

      const searchListProductos = async (idinv:string) =>{
        alertaService.showLoading("Espere...");
        setBusqEnd(false);
        //console.log(idinv);
        let invNum = parseInt(idinv, 10);
        await productoService.GetProductosIngresadosUsuarioSinProyecto(invNum,token)
        .then((data) => {
         //console.log(data)
         //setProductosIngresados(data.listData);
         if(data.status.isSuccessfully) {
            //console.log(data.listData)
            alertaService.hideLoading();
            setProductosIngresados(data.listData);
            alertaService.alertaExito("Exito","Se obtuvo respuesta.");
        }else{
            alertaService.hideLoading();
            alertaService.alertaAdvertencia("Alerta","No se encontraron resultados.");
        }
         })               
        .catch((error) => {
            alertaService.hideLoading();
            alertaService.alertaAdvertencia("Error",error);
            console.error(error)
        });
        setBusqEnd(true);
       };
    
      useEffect(() => {
        const flag = usuarioService.authorizedByRol(142,user.roles) || usuarioService.authorizedByRol(144,user.roles);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
       },[user]);

    return(
        <Container maxWidth="lg" sx={{mt:4}}>
          {auth ? 
          <>
            <Typography variant="h4" gutterBottom>
            <strong>Busqueda para Adjuntar Proyecto</strong> 
            </Typography>
            {ready ?
            <>
            <Select
              className="app-select-react"
              classNamePrefix="select"
              defaultValue={listUser[0]}
              isDisabled={!ready}
              isLoading={!ready}
              isSearchable={ready}
              name="usuario"
              options={listUser}
              onChange={(e) => searchListProductos(e?.value || '')}
            />
            <br />
            <Alert severity="info">
                <AlertTitle>Info</AlertTitle>
                    Estimado usuario, en esta sección observara todos los productos terminados por investigador que no se encuentran adjuntos a un proyecto.
            </Alert>
            <br />
            {busqEnd ? 
            <TableProductosSinProy rowsPerPage={[5 ,10, 25, 100]} data={productosIngresados} ready={ready} mostrarAlert={false}/>
            :
            <Stack sx={{ width: '100%' }} spacing={2}>
                <CircularProgress color="secondary" />
            </Stack>
            }
            </>
            : 
            <Stack sx={{ width: '100%' }} spacing={2}>
                <LinearProgress color="primary" />
            </Stack>}            
          </>
          :
          <UnauthorizedPage />
          }
        </Container>
    );
}